<template>
  <div class="nousan-components">
    <MyModal @close="closeModal" v-if="modal">
      <!-- default スロットコンテンツ -->
      <div class="iframe-wrapper">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/PaQ8ZO1ymFk" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <!-- /default -->
    </MyModal>
    <div class="nousan">
      <div class="head-wrapper">
        <div class="jumbotron">
          <img src="../../assets/img/job/nousan/jumbotron.jpg" alt="" class="over_display">
          <img src="../../assets/img/job/nousan/jumbotron_under.jpg" alt="" class="under_display">
        </div>
        <div class="message-tile">
          <div class="message-tile-inner">
            <div class="message">
              <img src="../../assets/img/job/nousan/catch.png" alt="春夏秋冬を色とボリュームで演出。お客様を迎えています。" width="390px">
            </div>
            <div class="movie-button" @click="openModal">
              <img src="../../assets/img/job/movie_button.png" alt="1分で仕事を見る" width="360px">
            </div>
          </div>
        </div>
      </div>
      <div class="main-contents">
        <div class="type-section">
          <FukidashiTitle title="どんなタイプの先輩がいる？" />
          <TypeAnswer genre="nousan" message="同じ繰り返しより、<br>臨機応変な毎日を楽しみたい人。"/>
        </div>
        <div class="type-section">
          <FukidashiTitle title="1日でお客様と接する時間は？" />
          <Graph graphNumber="75" />
          <div class="details">
            <p>
            農産部は、スーパーの玄関口でお客様をお迎えする部門です。開店前や営業中のひととき、色鮮やかに四季折々の旬を感じられるように、野菜や果物を積み上げる。豊かな実りを演出する。目で楽しんでいただけるプレゼンテーションを築いている気分です。
            </p>
            <p>
            そんな細やかな気配りが求められる一方で、天候などの都合で日々変動する青果物の入荷状況に合わせて、臨機応変に売場をつくりかえていく大胆さも欠かせません。細かさと大胆さの二面性は、この仕事の特徴だと思います。
            </p>
            <p>
            珍しい野菜の特徴や、果物の味などをお客様に聞かれることは多いです。だから僕自身もそうですが、自分が取り扱っている商品に興味をもって、実際になんでも食べるのが好きな人にはとても向いている職場だと思います。
            </p>
          </div>
        </div>
        <ScheduleLink />
      </div>
    </div>
  </div>
</template>

<script>
import MyModal from '@/components/MyModal.vue'
import FukidashiTitle from '@/components/job/FukidashiTitle.vue'
import TypeAnswer from '@/components/job/TypeAnswer.vue'
import Graph from '@/components/job/Graph.vue'
import ScheduleLink from '@/components/job/ScheduleLink.vue'
export default {
  name: 'Nousan',
  components: {
    MyModal,
    FukidashiTitle,
    TypeAnswer,
    Graph,
    ScheduleLink
  },
  data() {
    return {
      modal: false,
    }
  },
  methods: {
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false
    },
  }
}
</script>
<style scoped lang="scss">
.iframe-wrapper{
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 56%;
  iframe{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.nousan {
  padding-bottom: 100px;
  margin: 0 auto;
  &:before {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    left: 0;
    top: 800px;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
  &:after {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    right: 0;
    top: 0;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
}
.head-wrapper {
  position: relative;
}
.jumbotron {
  margin: 0 auto;
  max-width: 1300px;
  width: 100%;
}
.message-tile {
  position: absolute;
  display: flex;
  top: 0;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  transform: translateX(-25%);
  @media print, screen and (max-width: 960px) {
    transform: translateX(0);
    width: 50%;
  }
}
.message-tile-inner {
  position: relative;
}
.movie-button {
  position: absolute;
  bottom: 30px;
  right: -30px;
  cursor: pointer;
  transition: opacity 0.2s ease;
  @media print, screen and (max-width: 960px) {
    right: -5px;
  }
  &:hover {
    opacity: 0.5;
  }
  img {
    vertical-align: middle;
  }
}
.main-contents {
  margin: 0 auto;
  margin-top: 100px;
  max-width: 750px;
  width: 100%;
  @media print, screen and (max-width: 750px) {
    width: 90%;
  }
}
.type-section + .type-section {
  margin-top: 100px;
}
.details {
  font-size: 12px;
  line-height: 2em;
  margin-top: 50px;
}
</style>
